export const PAYMENT_PAGE_AA = '/pages/aa/payment/index';
export const CHECKOUT_AA_SESSION_TIMER_MINUTES = 15;
